const manager_hotel = {
  average_concumption_per_night: "Consumo médio por noite",
};

export default manager_hotel;
